export const language = {
    title: 'เปลี่ยนภาษา',
    select_laguage: 'โปรดเลือกภาษา',
    thai: 'ภาษาไทย',
    english: 'ภาษาอังกฤษ',
    dropdown: {
        th: 'ไทย',
        en: 'ENG'
    }
}
